export enum UserPrivilegeType {
  SuperAdmin = "super_admin",
  Rakaz = "rakaz",
  Limited = "limited",
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-models/user-privilege-type.enum.ts